import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const data = [
  { time: '9h15', 'OD (TH+)': 0.165, 'OD (TH-)': 0.274 },
  { time: '10h30', 'OD (TH+)': 0.29, 'OD (TH-)': 0.41 },
  { time: '12h35', 'OD (TH+)': 0.35, 'OD (TH-)': 0.426 },
  { time: '13h25', 'OD (TH+)': 0.368, 'OD (TH-)': 0.489 },
  { time: '14h12', 'OD (TH+)': 0.436, 'OD (TH-)': null }, // Pour 14h12, il n'y a que des données pour TH+
];

function Figure2() {
  return (
    <div>
      <br></br>
      <u>Figure 2: Measure culture OD over time</u>
      <LineChart width={600} height={300} data={data} margin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="time" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="OD (TH+)" stroke="blue" />
        <Line type="monotone" dataKey="OD (TH-)" stroke="red" />
      </LineChart>
    </div>
  );
}

export default Figure2;